import { SafetyDashboard } from "./SafetyDashboard";

export default {
  list: SafetyDashboard,
};
